(() => {
  const reveal = () => {
    const nodes = document.querySelectorAll('.vivi-reveal:not(.vivi-visible)');

    if (!('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('vivi-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('vivi-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.18 }
    );

    nodes.forEach((node) => observer.observe(node));
  };

  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
